export default __webpack_public_path__ + "static/media/about-communal-area.c146c966.jpg";